import { useEffect } from 'react';
import { getToken, sendVersion } from '../auth/ApiAuth';

const VersionReporter = () => {
  useEffect(() => {
    const token = getToken();
    if (token) {
      sendVersion();
    }
  }, []);

  return null;
}

export default VersionReporter;
